import React, { useContext, useEffect, useState } from "react";
import { Pressable, ScrollView, StyleSheet, View } from "react-native";
import { FindifyDataContext } from "@/contexts/FindifyDataContext";
import { PlaceColors } from "./helpers/PlaceColors";
import { PlaceText } from "./components/PlaceText";
import { IconShadow } from "./helpers/DefaultShadows";
import { FindifySimpleHeader } from "./components/FindifySimpleHeader";
import { BasePage } from "./helpers/BasePage";
import { FindifyTopBarOverlay } from "./components/FindifyTopBarOverlay";
import { makeContentDetails } from "./PlaceContentDetails";
import { FindifyLoadingScreen } from "./components/FindifyLoadingScreen";
import { BottomNavigationPadding } from "./components/FindifyNavigation";
import { ContentDetailsType, PlaceContentDetailsInitialUseEffect } from "./helpers/DetailsHelpers";
import { useTranslation } from "react-i18next";
import { FindifyToast } from "./components/FindifyToast";
import uuid from 'react-native-uuid';

export const EventTicketsZone = ({ navigation, ...props }: any) => {
    const findifyDataContext = useContext(FindifyDataContext);
    const [event, setEvent] = useState<any>({});
    const [contentSlug, setContentSlug] = useState<any>();
    const [contentModule, setContentModule] = useState<any>();
    const [hideDate, setHideDate] = useState(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (props.route.params && props.route.params.content) {
            setEvent(props.route.params.content);
            setContentModule('events');
        } else {
            props.route.params.module = 'events';
            PlaceContentDetailsInitialUseEffect(props, findifyDataContext, setEvent, setContentSlug, setContentModule, setHideDate);
        }
    }, []);
    const [isLogged, setIsLogged] = useState(false);
    useEffect(() => {
        if (findifyDataContext?.userCustomerAccounts[findifyDataContext?.workspace?.workspace_id]) {
            setIsLogged(true);
        } else {
            setIsLogged(false);
        }
    }, [findifyDataContext?.userCustomerAccounts]);



    return <BasePage navigation={navigation}>
        <FindifyTopBarOverlay />
        {event &&
            <ScrollView
                bounces={false}
                showsHorizontalScrollIndicator={false}
                showsVerticalScrollIndicator={false}
                style={[styles.container, { backgroundColor: PlaceColors(findifyDataContext).background.get() }]}>
                {makeContentDetails(MakeContentDetailsPage, event, t, false, contentModule, navigation, findifyDataContext, isLogged)}
            </ScrollView>
        }
        {!event && <FindifyLoadingScreen />}
    </BasePage>;
}


const MakeContentDetailsPage = ({ isLogged, image, title, navigation, resume, description, dateString, rightActions, content, t, hideDate, module, findifyDataContext }: ContentDetailsType) => {
    const topTextStyle = {
        marginTop: 5,
        fontSize: 14,
        color: PlaceColors(findifyDataContext).text.withAlpha(160)
    };

    return <>
        <FindifySimpleHeader
            navigation={navigation}
            title={title}
            // actions={actionsList}
            image={image} />
        <View style={styles.text}>
            <View style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
            }}>
                <View>
                    {!hideDate
                        &&
                        <PlaceText style={{
                            marginTop: 5,
                            marginBottom: 10,
                            fontSize: 14,
                            color: PlaceColors(findifyDataContext).text.withAlpha(200)
                        }}>{dateString}</PlaceText>
                    }
                </View>
            </View>
            <PlaceText
                style={{
                    fontSize: 20,
                    color: PlaceColors(findifyDataContext).text.get(),
                    fontWeight: 'bold',
                    marginVertical: 10
                }}
            >{t('base.tickets.available_tickets')}</PlaceText>
            {content?.ticket_collections?.map((tc: any) => {
                return <Pressable
                    style={{
                        padding: 10,
                        marginBottom: 10,
                        backgroundColor: PlaceColors(findifyDataContext).alternateListBG.get(),
                        borderRadius: 10,
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                    }}
                    onPress={() => {
                        if (isLogged) {
                            navigation.navigate('EventTicketPage', {
                                content: content,
                                currentTicketCollection: tc,
                                content_id: content.event_id
                            })
                        } else {
                            FindifyToast({
                                id: uuid.v4(),
                                visibilityTime: 1500,
                                type: 'error',
                                message: t('checkout.error_user_need_to_login'),
                            })
                            return false;
                        }
                    }}
                >
                    <PlaceText
                        style={{
                            color: PlaceColors(findifyDataContext).text.get()
                        }}
                    >{tc.name}</PlaceText>
                </Pressable>

            })}


        </View >
    </>
}

const styles = StyleSheet.create({
    text: {
        padding: 10,
        paddingBottom: 10 + BottomNavigationPadding,
    },
    container: {
        height: '100%',
        width: '100%',
    },

    headerIcon: {
        padding: 5,
        ...IconShadow,
    }
})
